module.exports = __webpack_public_path__ + "assets/img/discord.64438da5.webp";